import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  Popover,
  Box,
  Link,
  Typography,
  Grid
} from "@mui/material";

import es from "./../locales/es.json";
import en from "./../locales/en.json";

import MenuItem from "@mui/material/MenuItem";
import Logo_NavbarMenu_CNA from "../assets/imgs/Navbar/logo_cna_navbar.webp";
import Icon_Espanol from "../assets/icons/Navbar/icon_bandera_chile.webp";
import Icon_English from "../assets/icons/Navbar/icon_bandera_usa.webp";

import Logo_Instagram_CNA from "../assets/icons/Footer/icon_instagram.svg";
import Logo_Linkedin_CNA from "../assets/icons/Footer/icon_linkedin.svg";
import Logo_Tiktok_CNA from "../assets/icons/Footer/icon_tiktok.svg";
import Logo_X_CNA from "../assets/icons/Footer/icon_x.svg";
import Logo_Youtube_CNA from "../assets/icons/Footer/icon_youtube.svg";

const NavbarDesktop = ({ value, menuItem, idiomaSeleccionado, setIdiomaSeleccionado }) => {
  // const defaultLanguage =
  //   localStorage.getItem("language") === null
  //     ? "es"
  //     : localStorage.getItem("language");

  const [nosotros, setNosotros] = useState(false);
  const [procedimientos, setProcedimientos] = useState(false);
  const [documentacion, setDocumentacion] = useState(false);
  const [tarifas, setTarifas] = useState(false);
  // const [idiomaSeleccionado, setIdiomaSeleccionado] = useState(
  //   defaultLanguage === "es" ? es : en
  // );

  const handleClickProcedimientos = (event) => {
    setProcedimientos(event.currentTarget);
  };

  const handleCloseProcedimientos = () => {
    setProcedimientos(false);
  };

  const handleClickDocumentos = (event) => {
    setDocumentacion(event.currentTarget);
  };

  const handleCloseDocumentos = () => {
    setDocumentacion(false);
  };

  const handleClickTarifas = (event) => {
    setTarifas(event.currentTarget);
  };

  const handleCloseTarifas = () => {
    setTarifas(false);
  };

  const handleClickNosotros = (event) => {
    setNosotros(event.currentTarget);
  };

  const handleCloseNosotros = () => {
    setNosotros(false);
  };

  const handleChangeLanguage = async () => {
    switch (idiomaSeleccionado) {
      case es:
        setIdiomaSeleccionado(en);
        await localStorage.setItem("language", "en");
        break;

      case en:
        setIdiomaSeleccionado(es);
        await localStorage.setItem("language", "es");
        break;

      default:
        setIdiomaSeleccionado(es);
        await localStorage.setItem("language", "es");
        break;
    }
  };

  const styles = {
    tabs: {
      textTransform: "capitalize",
      color: "#30406B",
      fontFamily: "TitilliumWeb-SemiBold",
      fontSize: "1.1rem",
      width: "200px",

      "@media(max-width: 1536px)": {
        width: "170px",
      },

      "@media(max-width: 1300px)": {
        fontSize: "1rem",
        width: "150px",
      },
    },

    footerRedes:{
      gap: "1em",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "end",
      marginLeft: "10px",
      marginRight: "10rem",
      marginTop: "0.5rem",
      alignItems: "center",
    },
    cambioIdioma:{
      cursor: "pointer",
    },
    cambioIdiomaImg:{
      cursor: "pointer",  
      marginRight: "-10px",
      width:"20px",
      height:"20px"
    },
    boxImg:{
      width:"20px",
      height:"20px"
    },

    menuItem: {
      color: "#172833",
      fontFamily: "TitilliumWeb-Regular",
      fontSize: "1rem",
      width: "200px",
      padding: "1rem",

      "@media(max-width: 1536px)": {
        width: "170px",
      },

      "@media(max-width: 1300px)": {
        width: "150px",
        paddingTop: "1rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        paddingBottom: "1rem",
        fontSize: "0.85rem",
      },
    },
  };

  const tabs = [
    {
      label: idiomaSeleccionado.menu[0],
      handleClick: handleClickNosotros,
    },
    {
      label: idiomaSeleccionado.menu[1],
      handleClick: handleClickProcedimientos,
    },
    {
      label: idiomaSeleccionado.menu[2],
      handleClick: handleClickDocumentos,
    },
    {
      label: idiomaSeleccionado.menu[3],
      handleClick: handleClickTarifas,
    },
  ];

  return (
    <AppBar sx={{ background: "#FFFFFF" }} position="static">
      
      <Box component="div">
        
        <Grid item xs={12} sx={styles.footerRedes}>
          <Box
            component="img"
            src={idiomaSeleccionado === es ? Icon_English : Icon_Espanol}
            alt={idiomaSeleccionado === es ? "Icono Bandera De Estados Unidos" : "Icono Bandera De Chile"}
            onClick={handleChangeLanguage}
            sx={styles.cambioIdiomaImg}
          />
          <Typography
            color="#172833"
            fontFamily="TitilliumWeb-Regular"
            fontSize="1rem"
            onClick={handleChangeLanguage}
            sx={styles.cambioIdioma}
          >
            {idiomaSeleccionado === es ? "English" : "Español"}
          </Typography>
          <Link href="https://www.instagram.com/centronacionaldearbitrajes/" sx={styles.boxImg} underline="none" target="cna-instagram" rel="noopener noreferrer">
            <Box
              component="img"
              src={Logo_Instagram_CNA}
              alt="Logo Del CNA (Centro Nacional De Arbitrajes)"
            />
          </Link>
          <Link href="https://cl.linkedin.com/company/centro-nacional-de-arbitrajes" sx={styles.boxImg} underline="none" target="cna-linkedin" rel="noopener noreferrer">
            <Box
              component="img"
              src={Logo_Linkedin_CNA}
              alt="Logo Del CNA (Centro Nacional De Arbitrajes)"
            />
          </Link>
          <Link href="https://www.tiktok.com/@arbitrajescna?is_from_webapp=1&sender_device=pc" sx={styles.boxImg} underline="none" target="cna-tiktok" rel="noopener noreferrer">
            <Box
              component="img"
              src={Logo_Tiktok_CNA}
              alt="Logo Del CNA (Centro Nacional De Arbitrajes)"
            />
          </Link>
          <Link href="https://x.com/cna_cl?s=20" underline="none" target="cna-x" sx={styles.boxImg} rel="noopener noreferrer">
            <Box
              component="img"
              src={Logo_X_CNA}
              alt="Logo Del CNA (Centro Nacional De Arbitrajes)"
            />
          </Link>
          <Link href="https://youtube.com/@centronacionaldearbitrajes9536?si=w072rAO0TtYZa6RE" sx={styles.boxImg} underline="none" target="cna-youtube" rel="noopener noreferrer">
            <Box
              component="img"
              src={Logo_Youtube_CNA}
              alt="Logo Del CNA (Centro Nacional De Arbitrajes)"
            />
          </Link>
        </Grid>
      </Box>
      <Toolbar>
        <Box component="div" pl={2} pr={2}>
          <Link href="/home" underline="none" color="#172833">
            <Box
              component="img"
              src={Logo_NavbarMenu_CNA}
              alt="Logo Del CNA (Centro Nacional De Arbitrajes)"
              width="45px"
              height="30px"
            />
          </Link>
        </Box>
        <Tabs
          textColor="inherit"
          // onChange={() => handleTabClick}
          sx={{ marginLeft: "auto" }}
          value={value || false}
        >
          {tabs.map((tab, index) => (
            <Tab
              label={tab.label}
              sx={styles.tabs}
              onClick={tab.handleClick}
              value={index + 1}
              key={tab.label}
            />
          ))}
          <Tab
            label="E-xpediente Virtual"
            sx={{ ...styles.tabs, textTransform: "none" }}
            value={5}
            href="/e-xpediente"
          />
          <Tab
            label={idiomaSeleccionado.menu[4]}
            sx={styles.tabs}
            value={6}
            href="/contacto"
          />

        </Tabs>

        <Popover
          id={nosotros ? "simple-popover" : undefined}
          open={nosotros}
          anchorEl={nosotros}
          onClose={handleCloseNosotros}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Link href="/nosotros/cna" underline="none" color="#172833">
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 1 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[0]}
            </MenuItem>
          </Link>
          <Link href="/nosotros/equipo" underline="none" color="#172833">
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 2 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[1]}
            </MenuItem>
          </Link>
          <Link
            href="/nosotros/arbitraje_pro_bonos"
            underline="none"
            color="#172833"
          >
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 3 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[2]}
            </MenuItem>
          </Link>
        </Popover>

        <Popover
          id={procedimientos ? "simple-popover" : undefined}
          open={procedimientos}
          anchorEl={procedimientos}
          onClose={handleCloseProcedimientos}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Link
            href="/procedimientos/servicios"
            underline="none"
            color="#172833"
          >
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 4 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[3]}
            </MenuItem>
          </Link>

          <Link
            href="/procedimientos/como_trabajamos"
            underline="none"
            color="#172833"
          >
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 5 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[4]}
            </MenuItem>
          </Link>
        </Popover>

        <Popover
          id={documentacion ? "simple-popover" : undefined}
          open={documentacion}
          anchorEl={documentacion}
          onClose={handleCloseDocumentos}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Link
            href="/documentacion/clausulas"
            underline="none"
            color="#172833"
          >
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 6 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[5]}
            </MenuItem>
          </Link>
          <Link
            href="/documentacion/reglamentos"
            underline="none"
            color="#172833"
          >
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 7 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[6]}
            </MenuItem>
          </Link>
          <Link
            href="/documentacion/otros_documentos"
            underline="none"
            color="#172833"
          >
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 8 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[7]}
            </MenuItem>
          </Link>
        </Popover>

        <Popover
          id={tarifas ? "simple-popover" : undefined}
          open={tarifas}
          anchorEl={tarifas}
          onClose={handleCloseTarifas}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Link href="/tarifas/tabla_tarifas" underline="none" color="#172833">
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 9 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[8]}
            </MenuItem>
          </Link>
          <Link
            href="/tarifas/simulador_tarifas"
            underline="none"
            color="#172833"
          >
            <MenuItem
              sx={styles.menuItem}
              {...(menuItem === 10 && {
                selected: true,
              })}
            >
              {idiomaSeleccionado.sub_menu[9]}
            </MenuItem>
          </Link>
        </Popover>

      </Toolbar>
    </AppBar>
  );
};

export default NavbarDesktop;
